import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end -mb-3 p-4" }
const _hoisted_2 = { class: "text-red-100 dark:text-red-200" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "px-4 pb-4" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "px-4 pb-4 justify-end"
}
const _hoisted_10 = { class: "flex justify-end -mb-3 p-4" }
const _hoisted_11 = { class: "text-green-100 dark:text-green-200" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "px-4 pb-4" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "px-4 pb-4 justify-end"
}
const _hoisted_19 = { class: "flex justify-end -mb-3 p-4" }
const _hoisted_20 = { class: "text-gray-500" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["aria-label"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "px-4 pb-4" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 0,
  class: "px-4 pb-4 justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_NotificationGroup = _resolveComponent("NotificationGroup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationGroup, { group: "error" }, {
      default: _withCtx(() => [
        _createVNode(_component_Notification, {
          maxNotifications: 1,
          enter: "transform ease-out duration-300 transition",
          "enter-from": "translate-y-2 opacity-0 translate-y-0 translate-x-4",
          "enter-to": "translate-y-0 opacity-100 translate-x-0",
          leave: "transition ease-in duration-500",
          "leave-from": "opacity-100",
          "leave-to": "opacity-0",
          move: "transition duration-500",
          "move-delay": "delay-300"
        }, {
          default: _withCtx(({ notifications, close }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications, (notification) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-red-700 dark:bg-red-950 border-l-4 border-neg rounded",
                key: notification.id
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("h2", _hoisted_2, _toDisplayString(notification.title ? notification.title : _ctx.t.GENERAL_ERROR), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center",
                    onClick: ($event: any) => (close(notification.id))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "table-cell w-6 h-6 text-red-100 hover:opacity-80 -mt-1",
                      "aria-label": _ctx.t.GENERAL_CLOSE,
                      fill: "currentColor",
                      viewBox: "0 0 20 20",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_6, 8, _hoisted_4))
                  ], 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", {
                    class: "text-red-300 break-words",
                    innerHTML: notification.text ? notification.text : _ctx.t.GENERAL_ERROR_CONTACTUS
                  }, null, 8, _hoisted_8)
                ]),
                (notification.to && notification.toTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        class: "ctaBg w-full p-2 max-w-sm",
                        onClick: ($event: any) => (close(notification.id)),
                        to: notification.to
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notification.toTitle), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_NotificationGroup, { group: "success" }, {
      default: _withCtx(() => [
        _createVNode(_component_Notification, {
          maxNotifications: 1,
          enter: "transform ease-out duration-300 transition",
          "enter-from": "translate-y-2 opacity-0 translate-y-0 translate-x-4",
          "enter-to": "translate-y-0 opacity-100 translate-x-0",
          leave: "transition ease-in duration-500",
          "leave-from": "opacity-100",
          "leave-to": "opacity-0",
          move: "transition duration-500",
          "move-delay": "delay-300"
        }, {
          default: _withCtx(({ notifications, close }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications, (notification) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-green-700 dark:bg-green-900 border-l-4 border-pos rounded",
                key: notification.id
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(notification.title ? notification.title : _ctx.t.GENERAL_SUCCESS), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center",
                    onClick: ($event: any) => (close(notification.id))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "table-cell w-6 h-6 text-green-100 hover:opacity-80 -mt-1",
                      "aria-label": _ctx.t.GENERAL_CLOSE,
                      fill: "currentColor",
                      viewBox: "0 0 20 20",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_15, 8, _hoisted_13))
                  ], 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", {
                    class: "text-green-300 break-words",
                    innerHTML: notification.text
                  }, null, 8, _hoisted_17)
                ]),
                (notification.to && notification.toTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        class: "ctaBg w-full p-2 max-w-sm",
                        onClick: ($event: any) => (close(notification.id)),
                        to: notification.to
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notification.toTitle), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_NotificationGroup, { group: "info" }, {
      default: _withCtx(() => [
        _createVNode(_component_Notification, {
          maxNotifications: 1,
          enter: "transform ease-out duration-300 transition",
          "enter-from": "translate-y-2 opacity-0 translate-y-0 translate-x-4",
          "enter-to": "translate-y-0 opacity-100 translate-x-0",
          leave: "transition ease-in duration-500",
          "leave-from": "opacity-100",
          "leave-to": "opacity-0",
          move: "transition duration-500",
          "move-delay": "delay-300"
        }, {
          default: _withCtx(({ notifications, close }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications, (notification) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fixed w-full right-0 md:mt-5 md:mr-5 z-50 md:max-w-md bg-gray-100 dark:bg-gray-900 border-l-4 border-gray-300 dark:border-gray-700 rounded",
                key: notification.id
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", _hoisted_20, _toDisplayString(notification.title ? notification.title : _ctx.t.GENERAL_INFO), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "cursor-pointer bg-transparent rounded text-sm ml-auto inline-flex items-center",
                    onClick: ($event: any) => (close(notification.id))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "table-cell w-6 h-6 text-gray-700 dark:text-gray-100 hover:opacity-80 -mt-1",
                      "aria-label": _ctx.t.GENERAL_CLOSE,
                      fill: "currentColor",
                      viewBox: "0 0 20 20",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_24, 8, _hoisted_22))
                  ], 8, _hoisted_21)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", {
                    class: "text-gray-400 break-words",
                    innerHTML: notification.text ? notification.text : _ctx.t.GENERAL_ERROR_CONTACTUS
                  }, null, 8, _hoisted_26)
                ]),
                (notification.to && notification.toTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_router_link, {
                        class: "ctaBg w-full p-2 max-w-sm",
                        onClick: ($event: any) => (close(notification.id)),
                        to: notification.to
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notification.toTitle), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}